import gql from "graphql-tag";
import { quoteFragment } from "./fragments";

export const addLeadPicksMutation = gql`
	mutation AddLeadPicks($leadKey: ID!, $providers: [ID]!) {
		addLeadPicks(leadKey: $leadKey, providers: $providers) {
			success
		}
	}
`;

export const updateQuoteByClientTokenMutationFragment = gql`
	${quoteFragment}
	fragment updateQuoteByClientTokenMutationFragment on UpdateOneQuotePayload {
		record {
			...quoteFragment
		}
	}
`;
